module.exports = __webpack_public_path__ + "img/map_active.db646240.svg";